module.exports = __webpack_public_path__ + "img/repair5.3beb0749.png";